import { createFeatureSelector, createSelector } from '@ngrx/store';
import { loginFeatureKey, LoginState } from '~login/store/login.reducer';

export const selectLoginState = createFeatureSelector<LoginState>(loginFeatureKey);

export const selectLoginStatus = createSelector(selectLoginState, (state) => state.status);
export const selectLoginError = createSelector(selectLoginState, (state) => state.error);
export const selectAuthToken = createSelector(selectLoginState, (state) => state.token);

export const selectLoginIsLoading = createSelector(selectLoginStatus, (status) => status === 'loading');
